(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global.CommercetoolsSdkMiddlewareLogger = {}));
})(this, (function (exports) { 'use strict';

  function createLoggerMiddleware() {
    return function (next) {
      return function (request, response) {
        var error = response.error,
            body = response.body,
            statusCode = response.statusCode;
        /* eslint-disable */

        console.log('Request: ', request);
        console.log('Response: ', {
          error: error,
          body: body,
          statusCode: statusCode
        });
        /* eslint-enable */

        next(request, response);
      };
    };
  }

  exports.createLoggerMiddleware = createLoggerMiddleware;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
